enum SearchValidationType {
    refDataSourceName ='Ref Data Source Name',
    fieldName ='Report Field Name',
    variableName ='Variable Name'
}

export default SearchValidationType;
